export const SYSTEM_SECTIONS = {
  SETTINGS: '$settings',
  SYSTEM: '$system',
};
